import Controller from '@ember/controller';

export default class BacklogInitiativesInitiativeWeeksController extends Controller {}
